<template>
  <!-- Logik-Komponente ohne eigenes Markup: arbeitet auf dem server-gerenderten DOM -->
  <span class="hidden" aria-hidden="true"></span>
</template>

<script>
// Port von Berts wg_stepByStep (jQuery): Tab-artige Schritt-Navigation.
// Klick auf einen Trigger aktiviert das Panel mit derselben Position; der
// erste Schritt ist beim Laden aktiv.
//
// Markup-Vertrag (siehe StepByStep.fusion): Vue wird auf ein LEERES
// <div data-vue-steps></div> innerhalb des Modul-Roots [data-steps-root]
// gemountet (Mounten ersetzt innerHTML, daher darf der Mount-Punkt keinen
// Server-Inhalt tragen — gleiches Muster wie ImageSlider.vue).
//   [data-step-trigger][data-step-position="…"]  Navigations-Button
//   [data-step-panel][data-step-position="…"]    zugehöriger Inhalt
// Aktiv-Zustand wird als data-active="true|false" gesetzt; das Styling
// passiert in Fusion über Tailwind data-[active=true]:* Varianten.
export default {
  name: 'StepByStep',
  data() {
    return {
      triggers: [],
      panels: [],
      listeners: [],
    }
  },
  mounted() {
    const root = this.$el.closest('[data-steps-root]') || this.$el.parentElement
    if (!root) {
      return
    }
    this.triggers = Array.from(root.querySelectorAll('[data-step-trigger]'))
    this.panels = Array.from(root.querySelectorAll('[data-step-panel]'))
    if (this.triggers.length === 0) {
      return
    }

    // Erster Schritt aktiv (Bert: trigger.first().addClass('active'))
    this.activate(this.triggers[0].getAttribute('data-step-position'))

    this.triggers.forEach((trigger) => {
      const handler = () => {
        // Bereits aktiver Schritt: nichts tun (wie bei Bert)
        if (trigger.getAttribute('data-active') === 'true') {
          return
        }
        this.activate(trigger.getAttribute('data-step-position'))
      }
      trigger.addEventListener('click', handler)
      this.listeners.push({ trigger, handler })
    })
  },
  beforeUnmount() {
    this.listeners.forEach(({ trigger, handler }) => {
      trigger.removeEventListener('click', handler)
    })
    this.listeners = []
  },
  methods: {
    activate(position) {
      this.triggers.forEach((trigger) => {
        trigger.setAttribute(
          'data-active',
          trigger.getAttribute('data-step-position') === position ? 'true' : 'false'
        )
      })
      this.panels.forEach((panel) => {
        panel.setAttribute(
          'data-active',
          panel.getAttribute('data-step-position') === position ? 'true' : 'false'
        )
      })
    },
  },
}
</script>
